import type { BaseTranslation } from "../i18n-types";

const tl = {
	WELCOME_LONG: "Maligayang pagdating sa Unicorn Digital Courtroom",
	WELCOME: "Maligayang pagdating {name}!",
	JOIN_ROOM_DESCRIPTION:
		"Sumali sa isang silid sa ibaba o gumawa ng sarili mong silid!",
	NO_ROOM:
		"Hindi mo makita ang silid na hinahanap mo? Gumawa ng sarili mong silid.",
	CREATE_ROOM: "Gumawa ng Silid",
	ROOM: "Silid",
	ACCESSIBILITY_SETTINGS: "Mga Setting ng Accessibility",
	ACCESSIBILITY_SETTINGS_DESCRIPTION:
		"Baguhin ang mga setting ng accessibility dito",
	CONTRAST: "Kontrasta",
	SELECT_DISPLAY_NAME: "Pakilagay ang display name na nais mong gamitin",
	SOMETHING_WENT_WRONG: "Naku! May nangyaring mali.",
	GO_BACK: "Bumalik",
	GO_BACK_TO_ROOM: "Bumalik sa Silid",
	EXPAND: "Palawakin",
	EXPORT: "I-export",
	JOIN_ROOM: "Sumali sa Silid",
	ROOM_ENDED_TITLE: "Natapos na ang Silid",
	ROOM_ENDED_DESCRIPTION:
		"Natapos na ang silid, ikaw ay ire-redirect sa home screen",
	RENAME_FAILED: "Nabigong palitan ang pangalan.",
	TRANSCRIPT_DISCLAIMER:
		"Isang transcript base sa mga nakilalang tagapagsalita. Kailangan mong magsalita ng higit sa 7 segundo upang makilala.",
	CHANGE_SPEAKER_TITLE: "Palitan ang Tagapagsalita",
	CHANGE_SPEAKER_DESCRIPTION:
		"Palitan ang pangalan at kulay ng tagapagsalita dito",
	PREVIEW_MESSAGE: "Ito ay isang preview na mensahe",
	COLOR: "Kulay",
	NAME: "Pangalan",
	CANCEL: "Kanselahin",
	LANGUAGE: "Wika",
	SAVE: "I-save",
	ROOM_ID: "ID ng Silid",
	ROOM_ID_FORM_PLACEHOLDER: "Ilagay ang ID ng silid upang sumali",
	ROOM_ID_FORM_REQUIRED: "Kinakailangan ang Room ID upang sumali",
	ROOM_ID_FORM_MIN_LENGTH: "Ang Room ID ay dapat may 17 na karakter",
	LOGIN: "Mag-login",
	ROOM_COL: "Silid:",
	LANGUAGE_COL: "Wika",
	END_ROOM: "Tapusin ang Silid",
	JOIN_NOW: "Sumali Ngayon",
	LOGIN_FORM: {
		TOAST_TITLE: "Nakalog-in na!",
		TOAST_DESCRIPTION: "Maaari ka nang gumawa o sumali sa isang silid!",
		DISPLAY_NAME: "Display Name",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Ilagay ang display name",
		DISPLAY_NAME_FORM_SHORT:
			"Ang display name ay dapat may hindi bababa sa 3 karakter",
		DISPLAY_NAME_FORM_LONG:
			"Ang display name ay dapat hindi hihigit sa 32 karakter",
		DISPLAY_NAME_FORM_REQUIRED: "Kinakailangan ang display name",
	},
	PROFILE_FORM: {
		TITLE: "Kumpletuhin ang inyong Profile",
		DESCRIPTION: "Pakipalagay ang inyong display name upang magsimula",
		TOAST_SUCCESS_TITLE: "Na-update na ang Profile!",
		TOAST_SUCCESS_DESCRIPTION: "Matagumpay na na-save ang inyong profile.",
		TOAST_ERROR_TITLE: "Hindi Na-update",
		TOAST_ERROR_DESCRIPTION:
			"Hindi na-update ang inyong profile. Pakisubukan ulit.",
		SUBMIT_BUTTON: "I-save ang Profile",
	},
	NO_ROOMS_LIST: "Oops, walang nahanap na mga silid.",
	SEARCH_FOR_A_ROOM: "Maghanap ng silid",
	AUTH_ERROR_DESCRIPTION:
		"Nagkaroon ng problema sa pag-authenticate sa iyo. Paki-refresh.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Burahin ang Silid",
		DESCRIPTION: "Sigurado ka bang gusto mong burahin ang silid na ito?",
		CANCEL: "Kanselahin",
		DELETE: "Burahin",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Nalikha ang Kuwarto",
		DESCRIPTION: "Handa nang salihan ang iyong kuwarto.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "Magtakda ng pangalan ng silid na makikita ng iba.",
		NAME_LABEL: "Pangalan ng Silid",
		NAME_PLACEHOLDER: "I-type ang pangalan ng silid",
		LANGUAGE: "Wika",
		LANGUAGE_PLACEHOLDER: "Pumili ng wika",
		AUTO_DETECT: "Awtomatikong Tukuyin",
		ENGLISH_US: "Ingles (Estados Unidos)",
		ENGLISH_IN: "Ingles (India)",
		ARABIC_KSA: "Arabe (Saudi Arabia)",
		SPANISH_CR: "Espanyol (Costa Rica)",
		CATALAN_ES: "Catalan (Spain)",
		PORTUGUESE_PT: "Portuges (Portugal)",
		PORTUGUESE_BR: "Portuges (Brazil)",
		ESTONIAN_EE: "Estonian (Estonia)",
		RUSSIAN_RU: "Ruso (Russia)",
		MALTESE_MT: "Maltese (Malta)",
		FILIPINO_PH: "Filipino (Pilipinas)",
		SPANISH_MX: "Espanyol (Mexico)",
		CHINESE_CN: "Tsino (Mandarin)",
		VIETNAMESE_VN: "Biyetnames (Vietnam)",
		KOREAN_KR: "Koreano (Korea)",
		HINDI_IN: "Hindi (India)",
		PERSIAN_IR: "Persian (Iran)",
		LANGUAGE_DESCRIPTION:
			"Pumili ng wika para sa silid, hindi mo na ito mababago pagkatapos.",
		INCPERSONDEFAULT: "Doe,Jane",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Pagdinig para sa Karampatang Aksyon",
		SCHEDULEDEFAULT: "11/28/2023, 10:30 am PST",
		ADVANCED: "Advanced settings",
		INCARCERATED_PERSON_PLACEHOLDER: "Ilagay ang iyong pangalan",
		CDC_PLACEHOLDER: "Ilagay ang CDC number",
		HEARING_TYPE_PLACEHOLDER: "Ilagay ang uri ng pagdinig",
		INCARCERATED_PERSON: "Nakakulong na tao",
		CDC: "CDC",
		HEARING_TYPE: "Uri ng Pagdinig",
		SCHEDULE: "Iskedyul",
		PICKDATE: "Pumili ng petsa",
		STEP_DETAILS: "Mga detalye",
		STEP_MODEL: "Modelo",
		CONTINUE: "Magpatuloy",
		BACK: "Bumalik",
		MODEL_TITLE: "Modelo ng transkripsyon",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "Oras",
		MINUTES: "Minuto",
		SECONDS: "Segundo",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Nabigong I-export",
		TOAST_FAILED_DESCRIPTION: "Hindi ma-export ang walang laman na transcript.",
		DOWNLOAD: "I-download",
		DOWNLOAD_DESCRIPTION:
			"Pumili ng format para sa export at paganahin ang karagdagang mga opsyon.",
		SELECT_FORMAT: "Pumili ng format",
		SELECT_FORMAT_PLACEHOLDER: "Pumili ng Export format",
		DOCUMENT: "Dokumento (.pdf)",
		SPREADSHEET: "Spreadsheet (.csv)",
		AUDIO: "Audio (.mp3)",
		DOCX: "Word Document (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Pagsasalin",
		BODY: "Gusto mo bang ilapat ang pagbabagong ito sa lahat ng transcript ng user na ito?",
		APPLY_TO_SPEAKER: "I-apply lamang sa user na ito",
		APPLY_ONCE: "I-apply lamang dito",
		APPLY_TO_ALL: "I-apply sa lahat ng mga user",

		TRANSLATE: "Isalin",
	},
	GUEST_FORM: {
		TITLE: "Guest Access",
		DESCRIPTION:
			"Ilagay ang inyong email address upang makatanggap ng secure login link",
		EMAIL_LABEL: "Email Address",
		EMAIL_PLACEHOLDER: "Ilagay ang email address",
		EMAIL_REQUIRED: "Kinakailangan ang email address",
		EMAIL_INVALID: "Pakipalagay ang wastong email address",
		SEND_LINK: "Ipadala ang Login Link",
		SUCCESS_TITLE: "Suriin ang inyong Email",
		SUCCESS_DESCRIPTION:
			"Nagpadala kami ng login link sa inyong email address. I-click ang link upang makapasok sa silid.",
		ERROR_TITLE: "May nangyaring mali",
		ERROR_DESCRIPTION: "Hindi naipadala ang login link. Pakisubukan ulit.",
		CANCEL: "Kanselahin",
	},
	START_DATE_TIME: "Petsa at Oras ng Pagsisimula",
	END_DATE_TIME: "Petsa at Oras ng Pagtatapos",
	REVERT_TO_ORIGINAL: "Ibalik sa Orihinal",
	SELECTED_LANGUAGE: "Piniling Wika",
	TRANSLATION_INFO: "Ang ilang transcript ay isinalin mula sa orihinal.",
	INVITE_GUEST: "Mag-imbita ng Bisita",
	INVITE_GUEST_DESCRIPTION:
		"Mag-imbita ng guest user sa kwarto sa pamamagitan ng pag-input ng kanilang pangalan at email address",
	CREATED_BY: "Nilikha ni",
	VIEW_ALL: "Tingnan Lahat",
	LOBBY: {
		LOBBY: "Lobby",
		WAITING_IN_LOBBY: "{name} ay nag hihintay sa lobby",
		USERS_WAITING_IN_LOBBY:
			"Pamahalaan ang mga user na kasalukuyang naghihintay sa lobby.",
		SEND_INVITE: "Magpadala ng Imbitasyon",
		ADMIT: "Papasukin",
		REJECT: "Tanggihan",
		NO_PARTICIPANTS: "Walang kalahok sa lobby.",
	},
	CLOSE: "Isara",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Maranasan ang real-time transcription na may advanced speaker recognition technology. Perpekto para sa mga meetings, interviews, at conferences.",
		CAROUSEL_STORY_2:
			"Ang high-contrast mode, customizable fonts, at multi-language support ay nagsisiguro na lahat ay makakagamit ng aming platform nang epektibo.",
		CAROUSEL_STORY_3:
			"Ang inyong mga pag-uusap ay protektado ng enterprise-grade security. Sumali sa libu-libong propesyonal na nagtitiwala sa uTranscribe.",
		CAROUSEL_STORY_4:
			"Pumili ng inyong identification method sa ibaba at magsimulang mag-transcribe sa loob ng ilang segundo. Walang kumplikadong setup na kailangan.",
		CDCR_TEAM_TITLE: "Koponan ng Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "Beripikadong Miyembro ng Staff",
		OR_CONTINUE_WITH: "o magpatuloy sa",
		GUEST_ACCESS_SUBTITLE:
			"Hindi ka miyembro? Sumali gamit ang inyong Meeting ID",
		WELCOME_TO: "Maligayang pagdating sa",
		CHOOSE_IDENTIFICATION: "Pakipili ang inyong pagkakakilanlan",
		NEED_HELP: "Kailangan ng tulong? Kumonekta sa aming Support Desk.",
		CALL_SUPPORT: "Tumawag sa 1-877-742-2135",
		EMAIL_SUPPORT: "Mag-email sa support@courtroom.tech",
	},
	SIZES: "Mga Sukat",
	DIAGNOSTICS: "Diagnostics",
	ROOM_BACKGROUND: "Likuran ng Kuwarto",
	NOT_AVAILABLE: "Hindi Magagamit",
	UNRECOGNIZED_SPEECH: "Hindi Tukuyin",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"Hindi tukuyin ang transcript. Pakisubukan ulit.",
	UNDETECTED: "Hindi nadetekta",
	MICROPHONE_QUALITY_WARNING:
		"Pakisuri ang kalidad ng mikropono upang mapabuti ang katumpakan o ayusin ang distansya ng mikropono",
	DIARIZATION: {
		UNDETECTED: "Hindi nadetekta",
		ACCURACY: "Kakayahan",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "ITN mascarado",
		LANGUAGE: "Wika",
		ORIGINAL_TEXT: "Orihinal na Teksto",
		SPEAKER: "Tagapagsalita",
	},
	LOW_ACCURACY_WARNING: "Mababang Katumpakan",
	UNKNOWN: "Hindi kilala",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Mga setting ng transkripsyon",
		GENERAL: "Pangkalahatan",
		GENERAL_HINT: "Tema, font at wika",
		MODE_HINT: "Pag-uugali ng transkripsiyon",
		MODEL_HINT: "AI processing engine",
		MODE: "Mode",
		LIVE_TRANSCRIPTION: "Live Transcription",
		SEGMENTED_TRANSCRIPTION: "Segmented Transcription",
		FINAL_TRANSCRIPTION: "Final Transcription",
		LIVE_DESC:
			"Makikita ang live transcript ng iyong sariling pagsasalita sa hiwalay na pane habang nagsasalita. Ipinapakita ng pangunahing pane ang final transcript para sa lahat ng tagapagsalita.",
		SEGMENTED_DESC:
			"Ipakita ang pansamantalang segmented transcript sa real-time, awtomatikong ina-update sa final version.",
		FINAL_DESC:
			"Ipakita lamang ang final transcript sa pangunahing pane. Walang ipinapakitang live transcription.",
		SPEED_VALUE: "Bilis: {value}x",
		SPEED: "Bilis",
		FONT_TEST:
			"Binabago ng UTranscribe ang paraan kung paano natin kinukuha at nauunawaan ang pananalita.",
		FONT_SIZE: "Laki ng font",
		SPEED_DESC: "Bilis at pagkaantala ng transkripsyon",
		DELAY_DESC:
			"Bilis na {speed:number}x = pagkaantala ng {delay:number} segundo",
		MODEL: "Modelo",
		MODEL_TITLE: "Modelo ng Transkripsyon",
		MODEL_DESC: "Piliin ang AI model na ginagamit para sa pagproseso ng iyong mga transkripsyon.",
		MODEL_DEFAULT: "Default",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "GPT-4o",
		MODEL_GPT4O_MINI: "GPT-4o Mini",
		MODEL_FAST: "Allicorn Model 2",
		MODEL_DEFAULT_DESC:
			"Microsoft diarization service na may mabilis na pagpoproseso at maaasahang katumpakan para sa karamihan ng mga kaso ng paggamit.",
		MODEL_DEFAULT_SHORT_DESC:
			"Mabilis at maaasahang speaker diarization para sa karamihan ng mga kaso ng paggamit.",
		MODEL_WHISPER_DESC:
			"Allicorn Model 1 na may pinahusay na katumpakan para sa mga kumplikadong kapaligiran ng audio at espesyal na bokabularyo.",
		MODEL_WHISPER_SHORT_DESC:
			"Mataas na katumpakan para sa kumplikadong audio at mga espesyal na termino.",
		MODEL_GPT4O_DESC:
			"OpenAI GPT-4o transcription model na may pinakamataas na katumpakan at pag-unawa sa wika.",
		MODEL_GPT4O_SHORT_DESC:
			"Pinakamataas na katumpakan ng transkripsyon at pag-unawa sa wika.",
		MODEL_GPT4O_MINI_DESC:
			"OpenAI GPT-4o Mini transcription model na nagbabalanse ng katumpakan at bilis.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"Balanse na katumpakan at bilis ng transkripsyon.",
		MODEL_FAST_DESC:
			"Allicorn Model 2 transcription service na na-optimize para sa mababang latency na pagpoproseso.",
		MODEL_FAST_SHORT_DESC:
			"Mababang latency na pagpoproseso ng transkripsyon.",
		MODEL_ENHANCED: "Pinahusay",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "Na-optimize para sa matematika",
		DOMAIN_MATH_DESC:
			"Ipinapakita ang mga binibigkas na simbolo at equation sa matematika bilang totoong notation sa halip na plain text.",
	},
	NO_AUDIO: "Walang natukoy na audio",
	NO_AUDIO_DESC:
		"Ang iyong mikropono ay naka-unmute ngunit walang natutukoy na audio. Pakisuri ang iyong mga setting ng mikropono o lumipat sa ibang mikropono.",
	NO_TRANSCRIPTION: "Walang nalikhang transkripsyon",
	NO_TRANSCRIPTION_DESC:
		"Walang nalilikhang mga transkripsyon. Pakirefresh ang pahina.",
	SCROLLING_PAUSED: "Ang pag-scroll pababa ay naka-pause",
	RESUME: "Ipagpatuloy",
} satisfies BaseTranslation;

export default tl;
